import { AppealStatus, AppealStatusLabels } from "../enums/appealStatus";
import { AppealType, AppealTypeLabels } from "../enums/appealType";
import { BadgeOption } from "./submissionSummaryOptions";

/** Dropdown options for the Appeal Type field in the Appeal Info modal. */
export const APPEAL_TYPE_OPTIONS: BadgeOption[] = [
  {
    id: AppealType.FAX,
    text: AppealTypeLabels[AppealType.FAX],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: AppealType.PHONE,
    text: AppealTypeLabels[AppealType.PHONE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: AppealType.PORTAL,
    text: AppealTypeLabels[AppealType.PORTAL],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: AppealType.MAIL,
    text: AppealTypeLabels[AppealType.MAIL],
    textColor: "black",
    bgColor: "white",
  },
];

/**
 * Dropdown options for Appeal Status in the Appeal Info modal.
 * `id` values are the exact backend `AppealStatus` strings so save round-trips
 * without collapsing Submitted / Appeal Approved / Appeal Denied.
 */
export const APPEAL_STATUS_OPTIONS: BadgeOption[] = [
  {
    id: "Not Started",
    text: "Not Started",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: "In Progress",
    text: AppealStatusLabels[AppealStatus.IN_PROGRESS],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: "Submitted",
    text: "Submitted",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: "Done",
    text: AppealStatusLabels[AppealStatus.DONE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: "Appeal Approved",
    text: "Appeal Approved",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: "Appeal Denied",
    text: "Appeal Denied",
    textColor: "black",
    bgColor: "white",
  },
];
